import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=5de5244b&scoped=true&"
import script from "./Referral.vue?vue&type=script&lang=js&"
export * from "./Referral.vue?vue&type=script&lang=js&"
import style0 from "./Referral.vue?vue&type=style&index=0&id=5de5244b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de5244b",
  null
  
)

export default component.exports